// app/layout.tsx
import { ClerkProvider } from '@clerk/nextjs';
import '../styles/globals.css'; // Ensure you import the global styles here

export default function RootLayout({ children }: { children: React.ReactNode }) {
    return (
        <ClerkProvider>
            <html lang="en">
                <body>{children}</body>
            </html>
        </ClerkProvider>
    );
}